//
//
//
//

import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import { mapGetters, createNamespacedHelpers } from 'vuex'
import MonetateHelper from '@/scripts/libs/MonetateHelper'
import wcs from '@/scripts/libs/wcs'

const { mapGetters: mapGettersPdp } = createNamespacedHelpers('pdp')
const { mapGetters: mapGettersPlp } = createNamespacedHelpers('plp')

export default {
  name: 'rb-monetate',
  computed: {
    ...mapGetters(['cartIsLoading', 'cartItems']),
    ...mapGettersPdp(['breadcrumbs', 'selectedProduct']),
    ...mapGettersPlp(['products']),
    isInTYP() {
      return wcs.isInTYP()
    },
    isInPDP() {
      return wcs.isInPdp()
    },
    isInPLP() {
      return wcs.isInPlp()
    },
  },
  watch: {
    selectedProduct(newVal, oldVal) {
      if (oldVal.catEntryId !== newVal.catEntryId && !this.isInTYP && !isEmpty(this.breadcrumbs)) {
        MonetateHelper.reTrack()
      }
    },
    cartItems(newVal, oldVal) {
      if (!this.isInTYP && !this.cartIsLoading && !isEqual(newVal, oldVal)) {
        MonetateHelper.reTrack()
      }
    },
    products(newVal, oldVal) {
      if (this.isInPLP && !isEqual(newVal, oldVal)) {
        MonetateHelper.reTrack()
      }
    },
  },
  mounted() {
    MonetateHelper.initMonetate({
      vuexStore: this.$store,
    })
  },
}
